export const normalizePhone = (num) => {
  if (!num) return null;
  return num.replace(/[^\d+]/g, '');
};

export const normalizeEmail = (email) => {
  if (!email) return null;
  return email.trim().toLowerCase();
};

export const validateLatLng = (lat, lng) => {
  if (lat == null && lng == null) return true;
  if (lat == null || lng == null) return false;
  const numLat = Number(lat);
  const numLng = Number(lng);
  return (
    !isNaN(numLat) && !isNaN(numLng) &&
    numLat >= -90 && numLat <= 90 &&
    numLng >= -180 && numLng <= 180
  );
};

export const calculateDeleteAfter = (closedDate) => {
  if (!closedDate) return null;
  const deleteDate = new Date(closedDate);
  deleteDate.setDate(deleteDate.getDate() + 30);
  return deleteDate;
};

export const generateRefNumber = () => {
  return 'GH-' + Math.random().toString(36).substring(2, 8).toUpperCase();
};
